<template>
  <q-page class="q-px-md">
    <h4 v-if="places.length === 0" class="text-center text-grey-7">
      {{ $t('common.noControlPending') }}
      <br />{{ $t('common.thisWeek') }}
    </h4>
    <template v-for="place in places" :key="place.id">
      <div
        class="row q-py-md"
        @click="
          $router.push(`/zones/${place.zone.id}/places/${place.id}?tab=myScope`)
        "
      >
        <div class="col-xs-2 col-sm-3 col-md-4 col-lg-5">
          <q-btn
            round
            color="primary"
            size="15px"
            :key="'btn' + place.id"
            class="float-right"
          >
            <q-icon name="place" size="30px" />
          </q-btn>
        </div>
        <div class="col-xs-10 col-sm-9 col-md-8 col-lg-7 q-pl-sm">
          <span class="uppercase">{{ place.name }}</span>
          <span class="q-caption">
            <br />
            <i>( {{ displayNbControls(place.auditsCount) }} )</i>
          </span>
        </div>
      </div>
    </template>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { alphabeticalSort } from 'src/utils/sort'

export default {
  data() {
    return {
      places: []
    }
  },
  mounted() {
    this.setPlaces()
  },
  computed: {
    ...mapGetters({
      allAudits: 'audits/all',
      categories: 'company/categories'
    })
  },
  watch: {
    allAudits() {
      this.setPlaces()
    }
  },
  methods: {
    async reducedPlaces(residenceId) {
      const pendingAudits = (
        await this.$DB.tmpReports().find({
          selector: {
            status: {
              $in: ['IN_PROGRESS', 'PENDING', 'DONE']
            }
          }
        })
      ).docs.map((r) => r.audit.id)
      const zoneAudits = (
        await this.$patrimoine.auditsCollection().find({
          selector: {
            id: {
              $in: this.allAudits,
              $nin: pendingAudits
            },
            'place.zone.id': {
              $eq: parseInt(residenceId)
            }
          }
        })
      ).docs
      let places = this.$helpers.removeDuplicates(
        Array.from(zoneAudits, (audit) => audit.place),
        'id'
      )
      places.forEach((place) => {
        let placeAudits = zoneAudits.filter(
          (audit) => audit.place.id === place.id
        )
        place.auditsCount = placeAudits.length
      })
      return alphabeticalSort(places, (place) => place.name)
    },
    async setPlaces() {
      this.places = await this.reducedPlaces(this.$route.params.id)
      if (this.places.length === 0) {
        this.$router.go(-1)
      } else {
        this.$emit('title', this.places[0].zone.name)
      }
    },
    displayNbControls(count) {
      if (count > 1) {
        return count + ` ${this.$t('navigation.audits').toLocaleLowerCase()}`
      } else {
        return count + ` ${this.$t('common.audit').toLocaleLowerCase()}`
      }
    }
  }
}
</script>
